import React, { useEffect, createElement } from 'react';
import { motion } from 'framer-motion';
import { UsersIcon, ZapIcon, FilterIcon, CalendarCheckIcon } from 'lucide-react';
// Declare wistia-player as a valid JSX element
declare global {
  namespace JSX {
    interface IntrinsicElements {
      'wistia-player': React.DetailedHTMLProps<React.HTMLAttributes<HTMLElement> & {
        'media-id': string;
        aspect?: string;
      }, HTMLElement>;
    }
  }
}
export function HowItWorks() {
  const steps = [{
    num: '01',
    icon: UsersIcon,
    title: 'Llega el Interesado',
    desc: 'Te escribe por WhatsApp, Instagram, Messenger o TikTok'
  }, {
    num: '02',
    icon: ZapIcon,
    title: 'Respuesta en Segundos',
    desc: 'La IA contesta al instante, 24/7, hablando como tu negocio'
  }, {
    num: '03',
    icon: FilterIcon,
    title: 'Califica y Filtra',
    desc: 'Identifica quién está listo para comprar'
  }, {
    num: '04',
    icon: CalendarCheckIcon,
    title: 'Agenda la Cita',
    desc: 'Coordina la reunión directo en tu calendario'
  }];
  useEffect(() => {
    // Inject Wistia player runtime
    const playerScript = document.createElement('script');
    playerScript.src = 'https://fast.wistia.com/player.js';
    playerScript.async = true;
    document.body.appendChild(playerScript);
    // Inject this video's embed script
    const mediaScript = document.createElement('script');
    mediaScript.src = 'https://fast.wistia.com/embed/r5gmudcxaa.js';
    mediaScript.async = true;
    mediaScript.type = 'module';
    document.body.appendChild(mediaScript);
  }, []);
  return <section className="py-24 bg-navy-deep relative" data-id="element-103">
      <div className="max-w-7xl mx-auto px-6" data-id="element-104">
        <div className="text-center mb-20" data-id="element-105">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl lg:text-5xl font-bold text-white" data-id="element-106">
            ¿Cómo Funciona?
          </motion.h2>
        </div>

        <div className="relative" data-id="element-107">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-1/2 left-0 right-0 h-0.5 bg-primary/10 -translate-y-1/2 z-0" data-id="element-108" />

          {/* Connecting Line (Mobile) */}
          <div className="md:hidden absolute left-8 top-0 bottom-0 w-0.5 bg-primary/10 z-0" data-id="element-109" />

          <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-6 relative z-10" data-id="element-110">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.15
          }} className="relative flex md:flex-col items-start md:items-center text-left md:text-center gap-6 md:gap-4" data-id="element-111">
                <div className="w-16 h-16 rounded-2xl bg-surface border border-primary/30 flex items-center justify-center shrink-0 shadow-[0_0_20px_rgba(0,180,216,0.15)] relative" data-id="element-112">
                  <span className="absolute -top-3 -right-3 text-xs font-bold bg-primary text-navy-deep px-2 py-1 rounded-md" data-id="element-113">
                    {step.num}
                  </span>
                  <step.icon className="w-7 h-7 text-primary" data-id="element-114" />
                </div>

                <div data-id="element-115">
                  <h3 className="text-xl font-bold text-white mb-2" data-id="element-116">
                    {step.title}
                  </h3>
                  <p className="text-muted text-sm md:text-base leading-relaxed" data-id="element-117">
                    {step.desc}
                  </p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="relative mx-auto mt-20 w-full max-w-md md:max-w-lg" data-id="element-118">
          <div className="absolute -inset-4 bg-primary/20 rounded-2xl blur-3xl -z-10" data-id="element-119" />
          <div className="relative rounded-2xl overflow-hidden border border-primary/30 shadow-[0_0_40px_rgba(0,180,216,0.25)] bg-navy-deep" data-id="element-120">
            <wistia-player media-id="r5gmudcxaa" aspect="0.8" style={{
            display: 'block',
            width: '100%'
          }} data-id="element-121" />
          </div>
        </motion.div>
      </div>
    </section>;
}